
export default {
  productData: {
    serialNumber: 'DA-HOU-002',
    name: 'Holzbalkendecken ohne Unterdecken l Aufbau 2',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Gipsfaserplatte GF oder zementgebundene Spanplatte ZSP' },
          output: '25',
          value: 'd-25'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 24 MN/m<sup>3</sup>; Anwendungsgebiet DES-sg)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung, (<i>m‘</i> ≥ 90 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 60',
          value: 'scsb-60'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken' },
          output: '220',
          value: 'b-220'
        }
      ],
      sum: {
        output: '347', value: 347
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '57 (-1)', value: 57
      },
      soundReductionIndex: { // Rw
        output: '64 (-4; -11)', value: 64
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,56', value: 0.56
      },
      fireResistance: {
        output: '-', value: null
      },
      massPerUnitArea: {
        output: '153,4 [kg/m²]'
      }
    }
  },
  image: 'da-hou-002.png',
  pdf: 'Holzbalkendecken-ohne-Unteredecke-Aufbau-2-DA-HOU-002-Rev03.pdf'
}
